import { Injectable } from '@angular/core';
import { MatSnackBar,MatDialog, DialogRole } from '@angular/material';
import { AlertDialogComponent } from '../components/alert-dialog/alert-dialog.component';
import {PictureDialogComponent} from '../components/picture-dialog/picture-dialog.component'
import { AlertDialogTypeEnum, AlertDialogConfirmTypeEnum} from '../_enums/_index';


@Injectable()
export class GeneralService {

    constructor(
        private dialog: MatDialog,
        private snackBar: MatSnackBar) {
    }

    setIsDirty(isDirty: string) {
        localStorage.setItem('isDirty', isDirty);
    }

    showSnackBar(message: string) {
        this.snackBar.open(message, "", {
            duration: 3000,
        });
    }

    showConfirmDialog(message: string, confirmType: AlertDialogConfirmTypeEnum=0): Promise<boolean> {
        let dialogRef = this.dialog.open(AlertDialogComponent);
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.alertDialogType = AlertDialogTypeEnum.Confirm;
        dialogRef.componentInstance.alertDialogConfirmType = confirmType;
        dialogRef.disableClose = true;
        return dialogRef.afterClosed().toPromise();
    }

    showErrorDialog(errorMessage: string) {
        let dialogRef = this.dialog.open(AlertDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.message = errorMessage;
        dialogRef.componentInstance.alertDialogType = AlertDialogTypeEnum.Warning;
    }

    showInformationDialog(message: string) {
        let dialogRef = this.dialog.open(AlertDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.alertDialogType = AlertDialogTypeEnum.Information;
    }

    showPictureDialog(dialogHeader:string,url:any) {
        let dialogRef = this.dialog.open(PictureDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = dialogHeader;
        dialogRef.componentInstance.url = url;
        
    }

    getMonthList()
    {
        let monthList: string[];
        monthList = [];
        monthList.push('01');
        monthList.push('02');
        monthList.push('03');
        monthList.push('04');
        monthList.push('05');
        monthList.push('06');
        monthList.push('07');
        monthList.push('08');
        monthList.push('09');
        monthList.push('10');
        monthList.push('11');
        monthList.push('12');
        return monthList;
    }

    validateTZ(num) {
        var tot = 0;
        var tz = new String(num);
        var x: any = 0;
        for (let i = 0; i < 8; i++) {
            x = (((i % 2) + 1) * parseInt(tz.charAt(i)));
            if (x > 9) {
                x = x.toString();
                x = parseInt(x.charAt(0)) + parseInt(x.charAt(1))
            }
            tot += x;
        }

        if ((tot + parseInt(tz.charAt(8))) % 10 == 0) {
            {
                return true;
            }
        }
        else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/general.service.ts